import React from 'react';
export function TagIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.113 10.459l-6.874-6.874A1.99 1.99 0 0012.826 3H5a2 2 0 00-2 2v7.826c.001.53.212 1.038.586 1.414l6.872 6.873a3 3 0 004.243 0l6.412-6.413a3 3 0 000-4.241zM19.7 13.287L13.287 19.7a1.021 1.021 0 01-1.414 0L5 12.826V5h7.826l6.874 6.873a1 1 0 010 1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.317 7.243l-.034.035a.965.965 0 000 1.364l.034.035a.965.965 0 001.365 0l.035-.035a.965.965 0 000-1.364l-.035-.035a.965.965 0 00-1.365 0z"
  }));
}